import React, { useEffect, useState } from "react";

export function formatTopNavDateTime(date = new Date()) {
  const weekday = date.toLocaleDateString("en-US", { weekday: "long" });
  const monthDayYear = date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const time = date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
  return `${weekday}, ${monthDayYear} ${time}`;
}

export default function TopNavDateTime({ className = "" }) {
  const [label, setLabel] = useState(() => formatTopNavDateTime());

  useEffect(() => {
    const tick = () => setLabel(formatTopNavDateTime());
    tick();
    const id = window.setInterval(tick, 30_000);
    return () => window.clearInterval(id);
  }, []);

  return (
    <time className={className} dateTime={new Date().toISOString()}>
      {label}
    </time>
  );
}
